<template>
    <!-- Admin → Usuarios (/admin/usuarios). Demo aprobada: Desktop/nuevo-usuarios.
         Lateral con cifras y "Para revisar"; a la derecha buscador, filtros y la
         lista. Al abrir un usuario, un panel con pestañas (resumen, actividad,
         datos, reservas, intakes, espacios, seguridad). API: AdminUsuariosController. -->
    <div class="us-page">
        <div class="bk us">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_usuarios.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_usuarios.title_a') }} <span class="bk-grad">{{ $t('admin_usuarios.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_usuarios.sub') }}</p>

                <div class="us-stats" aria-live="polite">
                    <template v-for="s in cifras">
                        <button v-if="s.f" :key="s.k" type="button" :class="['us-stat', { 'is-on': s.on }]" :aria-pressed="String(s.on)" @click="filtroCifra(s.f)">
                            <span class="us-stat-n">{{ numero(s.n) }}</span><span class="us-stat-k">{{ $t(`admin_usuarios.stat.${s.k}`) }}</span>
                        </button>
                        <div v-else :key="s.k" class="us-stat">
                            <span class="us-stat-n">{{ numero(s.n) }}</span><span class="us-stat-k">{{ $t(`admin_usuarios.stat.${s.k}`) }}</span>
                        </div>
                    </template>
                </div>

                <section class="us-care" aria-labelledby="us-care-title">
                    <h2 id="us-care-title">{{ $t('admin_usuarios.care.title') }}</h2>
                    <ul>
                        <li v-for="c in REVISAR" :key="c">
                            <button type="button" :class="['us-care-item', { 'is-on': f.ver === c }]" :aria-pressed="String(f.ver === c)" @click="cambiar('ver', f.ver === c ? '' : c)">
                                <span>{{ $t(`admin_usuarios.care.${c}`) }}</span>
                                <b>{{ resumen ? numero(resumen.revisar[c]) : '·' }}</b>
                                <span aria-hidden="true" v-html="IC.chev"></span>
                            </button>
                        </li>
                    </ul>
                </section>
            </aside>

            <section :class="['us-main', { 'is-cargando': cargando && filas.length }]" :aria-busy="String(cargando)" aria-labelledby="us-list-title">
                <div class="us-toolbar">
                    <label class="us-search">
                        <span aria-hidden="true" v-html="IC.search"></span>
                        <span class="us-sr">{{ $t('admin_usuarios.search_label') }}</span>
                        <input v-model="busqueda" type="search" autocomplete="off" :placeholder="$t('admin_usuarios.search_ph')" />
                    </label>
                    <div class="us-filter-row">
                        <div class="us-seg" role="group" :aria-label="$t('admin_usuarios.seg.label')">
                            <button
                                v-for="t in TIPOS"
                                :key="t || 'all'"
                                type="button"
                                :class="{ 'is-on': f.tipo === t }"
                                :aria-pressed="String(f.tipo === t)"
                                @click="cambiar('tipo', t)"
                            >{{ $t(`admin_usuarios.seg.${t || 'all'}`) }}</button>
                        </div>
                        <div class="us-selects">
                            <label class="us-sel"><span>{{ $t('admin_usuarios.f.act') }}</span>
                                <select :value="f.act" @change="cambiar('act', $event.target.value)">
                                    <option v-for="o in ACTIVIDAD" :key="o.v" :value="o.v">{{ $t(`admin_usuarios.f.${o.k}`) }}</option>
                                </select>
                            </label>
                            <label class="us-sel"><span>{{ $t('admin_usuarios.f.ver') }}</span>
                                <select :value="f.ver" @change="cambiar('ver', $event.target.value)">
                                    <option v-for="o in ESTADO" :key="o.v" :value="o.v">{{ $t(`admin_usuarios.f.${o.k}`) }}</option>
                                </select>
                            </label>
                            <label class="us-sel"><span>{{ $t('admin_usuarios.f.orden') }}</span>
                                <select :value="f.orden" @change="cambiar('orden', $event.target.value)">
                                    <option v-for="o in ORDEN" :key="o" :value="o">{{ $t(`admin_usuarios.f.o_${o}`) }}</option>
                                </select>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="us-head">
                    <h2 id="us-list-title" class="us-head-title">{{ $t(`admin_usuarios.seg.${f.tipo ? f.tipo : 'list_all'}`) }}</h2>
                    <span class="us-head-n">{{ $tc('admin_usuarios.results', total, { n: numero(total) }) }}</span>
                    <button v-if="filtrando" type="button" class="us-clear" @click="limpiar">{{ $t('admin_usuarios.clear') }}</button>
                </div>

                <div v-if="cargando && !filas.length" class="us-loading"><HyFLoader variant="inline" /></div>

                <div v-else-if="error" class="us-empty" role="alert">
                    <h3>{{ $t('admin_usuarios.error_title') }}</h3>
                    <p>{{ $t('admin_usuarios.error_text') }}</p>
                    <button type="button" class="bk-btn bk-btn--primary" @click="cargar">{{ $t('admin_usuarios.retry') }}</button>
                </div>

                <div v-else-if="!filas.length" class="us-empty">
                    <h3>{{ $t('admin_usuarios.empty_title') }}</h3>
                    <p>{{ $t('admin_usuarios.empty_text') }}</p>
                    <button v-if="filtrando" type="button" class="bk-btn bk-btn--ghost" @click="limpiar">{{ $t('admin_usuarios.clear') }}</button>
                </div>

                <template v-else>
                    <div class="us-cols" aria-hidden="true">
                        <span>{{ $t('admin_usuarios.cols.user') }}</span><span>{{ $t('admin_usuarios.cols.tags') }}</span><span>{{ $t('admin_usuarios.cols.last') }}</span><span>{{ $t('admin_usuarios.cols.act') }}</span><span></span>
                    </div>
                    <ul class="us-list">
                        <li v-for="(u, i) in filas" :key="u.idusuario" class="us-item" :style="{ animationDelay: `${i * 0.025}s` }">
                            <button
                                type="button"
                                :class="['us-row', { 'is-open': abiertoId === u.idusuario }]"
                                :data-u="u.idusuario"
                                :aria-label="$t('admin_usuarios.row.open', { n: nombre(u) })"
                                @click="abrir(u.idusuario, 'resumen', $event.currentTarget)"
                            >
                                <span class="us-c us-who">
                                    <span :class="['us-av', `us-av--${tipoCls(u)}`]" aria-hidden="true">{{ iniciales(u) }}</span>
                                    <span class="us-who-t">
                                        <b>{{ nombre(u) }}</b>
                                        <small>#{{ u.idusuario }} · {{ u.correo }}</small>
                                    </span>
                                </span>
                                <span class="us-c us-tags">
                                    <span v-for="b in insignias(u)" :key="b.t" :class="b.cls">{{ b.t }}</span>
                                </span>
                                <span class="us-c us-last">
                                    <b :class="vivo(u.ultimo_login)"><i aria-hidden="true"></i>{{ hace(u.ultimo_login) }}</b>
                                    <small>{{ u.ultimo_acceso ? `${u.ultimo_acceso.dispositivo || '—'} · ${u.ultimo_acceso.navegador || '—'}` : '—' }}</small>
                                </span>
                                <span class="us-c us-counts">
                                    <span ><b>{{ numero(u.reservas) }}</b> {{ $tc('admin_usuarios.row.reservas', u.reservas) }}</span>
                                    <span ><b>{{ numero(u.intakes_completos) }}</b> {{ $tc('admin_usuarios.row.intakes', u.intakes_completos) }}</span>
                                    <span v-if="u.es_anfitrion" ><b>{{ numero(u.espacios) }}</b> {{ $tc('admin_usuarios.row.espacios', u.espacios) }}</span>
                                </span>
                                <span class="us-go" aria-hidden="true" v-html="IC.chev"></span>
                            </button>
                        </li>
                    </ul>
                </template>

                <BkPaginacion v-if="!error && ultimaPagina > 1" :actual="pagina" :ultima="ultimaPagina" :total="total" @ir="irAPagina" />
            </section>
        </div>
        <!-- ═══════ Panel del usuario ═══════ -->
        <div v-if="abiertoId" :class="['us-drawer', { 'is-closing': cerrando }]" :style="{ '--us-cookies': cookiesAlto + 'px' }">
            <div class="us-drawer-bg" @click="cerrar"></div>
            <div ref="card" class="us-drawer-card" role="dialog" aria-modal="true" aria-labelledby="us-d-title" tabindex="-1">
                <div v-if="!det" class="us-d-wait">
                    <button type="button" class="us-x us-x--abs" :aria-label="$t('admin_usuarios.d.close')" @click="cerrar"><span aria-hidden="true" v-html="IC.x"></span></button>
                    <HyFLoader v-if="detCargando" variant="inline" />
                    <div v-else class="us-empty" role="alert">
                        <h3 id="us-d-title">{{ $t('admin_usuarios.d.error') }}</h3>
                        <button type="button" class="bk-btn bk-btn--primary" @click="cargarDetalle">{{ $t('admin_usuarios.retry') }}</button>
                    </div>
                </div>

                <template v-else>
                    <header class="us-d-top">
                        <div class="us-d-row">
                            <span :class="['us-av', 'us-av--lg', `us-av--${tipoCls(U)}`]" aria-hidden="true">{{ iniciales(U) }}</span>
                            <div class="us-d-name">
                                <h2 id="us-d-title">{{ nombre(U) }}</h2>
                                <p>{{ $t('admin_usuarios.d.user_n', { id: U.idusuario }) }}<template v-if="U.fecha_registro"> · {{ $t('admin_usuarios.d.since', { d: mesAnio(U.fecha_registro) }) }}</template> · {{ U.pais || $t('admin_usuarios.d.no_country') }}</p>
                            </div>
                            <button type="button" class="us-x" :aria-label="$t('admin_usuarios.d.close')" @click="cerrar"><span aria-hidden="true" v-html="IC.x"></span></button>
                        </div>
                        <div class="us-d-tags"><span v-for="b in insignias(U)" :key="b.t" :class="b.cls">{{ b.t }}</span></div>
                        <div class="us-d-quick">
                            <button type="button" class="us-chip-btn" :title="$t('admin_usuarios.d.copy')" @click="copiar(U.correo)"><span aria-hidden="true" v-html="IC.copy"></span><span>{{ U.correo }}</span></button>
                            <a class="us-chip-btn" :href="`mailto:${U.correo}`"><span aria-hidden="true" v-html="IC.mail"></span><span>{{ $t('admin_usuarios.d.write') }}</span></a>
                            <a v-if="telDigitos" class="us-chip-btn us-chip-btn--wa" :href="`https://wa.me/${telDigitos}`" target="_blank" rel="noopener"><span aria-hidden="true" v-html="IC.wa"></span><span>WhatsApp</span></a>
                            <router-link v-if="U.es_anfitrion" class="us-chip-btn" :to="{ name: 'admin-backoffice', query: { host: String(U.idusuario) } }"><span aria-hidden="true" v-html="IC.ext"></span><span>BackOffice</span></router-link>
                        </div>
                        <nav class="us-tabs" role="tablist" :aria-label="$t('admin_usuarios.d.tabs_label')" @keydown="flechasTabs">
                            <button
                                v-for="t in tabs"
                                :id="`us-tab-${t.k}`"
                                :key="t.k"
                                type="button"
                                role="tab"
                                aria-controls="us-panel"
                                :aria-selected="String(tab === t.k)"
                                :tabindex="tab === t.k ? 0 : -1"
                                :class="['us-tab', { 'is-on': tab === t.k }]"
                                @click="cambiarTab(t.k)"
                            >{{ $t(`admin_usuarios.tab.${t.k}`) }}<span v-if="t.n">{{ numero(t.n) }}</span></button>
                        </nav>
                    </header>

                    <div id="us-panel" :key="tab" class="us-d-body" role="tabpanel" :aria-labelledby="`us-tab-${tab}`">
                        <div v-if="bloqueo" class="us-note us-note--warn"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t(`admin_usuarios.e.locked_${bloqueo}`) }}</span></div>

                        <!-- ── Resumen ── -->
                        <template v-if="tab === 'resumen'">
                            <div class="us-figs">
                                <button type="button" class="us-fig" @click="irReservas('hechas')">
                                    <span class="us-fig-n">{{ numero(det.reservas.hechas_total) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.r.hechas') }}</span>
                                    <span v-if="det.reservas.hechas_resumen.pagadas" class="us-fig-s">{{ $tc('admin_usuarios.r.pagadas', det.reservas.hechas_resumen.pagadas, { n: det.reservas.hechas_resumen.pagadas }) }}</span>
                                </button>
                                <button v-if="U.es_anfitrion" type="button" class="us-fig" @click="irReservas('recibidas')">
                                    <span class="us-fig-n">{{ numero(det.reservas.recibidas_total) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.r.recibidas') }}</span>
                                    <span v-if="det.reservas.recibidas_resumen.por_responder" class="us-fig-s">{{ $t('admin_usuarios.r.por_resp', { n: det.reservas.recibidas_resumen.por_responder }) }}</span>
                                </button>
                                <button type="button" class="us-fig" @click="cambiarTab('intakes')">
                                    <span class="us-fig-n">{{ numero(det.intakes_completos) }}<small>/{{ numero(det.intakes_total) }}</small></span><span class="us-fig-k">{{ $t('admin_usuarios.r.intakes') }}</span>
                                    <span v-if="det.formularios.length" class="us-fig-s">{{ $tc('admin_usuarios.r.sin_terminar', det.formularios.length, { n: det.formularios.length }) }}</span>
                                </button>
                                <button v-if="U.es_anfitrion" type="button" class="us-fig" @click="cambiarTab('espacios')">
                                    <span class="us-fig-n">{{ numero(det.espacios.total) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.r.espacios') }}</span>
                                    <span class="us-fig-s">{{ $t('admin_usuarios.r.publicados', { n: det.espacios.publicados }) }}</span>
                                </button>
                                <div class="us-fig"><span class="us-fig-n">{{ numero(det.favoritos) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.r.favoritos') }}</span></div>
                                <div class="us-fig">
                                    <span class="us-fig-n">{{ numero(det.mensajes.conversaciones) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.r.conv') }}</span>
                                    <span v-if="det.mensajes.sin_leer" class="us-fig-s">{{ $t('admin_usuarios.r.sin_leer', { n: det.mensajes.sin_leer }) }}</span>
                                </div>
                            </div>

                            <div class="us-grid2">
                                <section class="us-card">
                                    <p class="us-card-k">{{ $t('admin_usuarios.r.last') }}</p>
                                    <p class="us-big">{{ hace(U.ultimo_login) }}</p>
                                    <p v-if="U.ultimo_login" class="us-muted">{{ $t('admin_usuarios.r.at', { d: dia(U.ultimo_login), h: hora(U.ultimo_login) }) }}</p>
                                    <ul v-if="acceso" class="us-kv">
                                        <li><span>{{ $t('admin_usuarios.r.device') }}</span><b>{{ acceso.dispositivo || '—' }} · {{ acceso.sistema_operativo || '—' }}</b></li>
                                        <li><span>{{ $t('admin_usuarios.r.browser') }}</span><b>{{ acceso.navegador || '—' }}</b></li>
                                        <li><span>{{ $t('admin_usuarios.r.method') }}</span><b>{{ $t(acceso.metodo === 'google' ? 'admin_usuarios.r.m_google' : 'admin_usuarios.r.m_password') }}</b></li>
                                        <li><span>{{ $t('admin_usuarios.r.ip') }}</span><b class="us-mono">{{ acceso.ip || '—' }}</b></li>
                                    </ul>
                                    <p v-else class="us-note"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_usuarios.r.no_access') }}</span></p>
                                    <p v-if="fallidos30" class="us-note us-note--warn">
                                        <span aria-hidden="true" v-html="IC.warn"></span>
                                        <span>{{ $tc('admin_usuarios.r.failed', fallidos30, { n: fallidos30 }) }} <button type="button" class="us-link" @click="cambiarTab('seguridad')">{{ $t('admin_usuarios.r.see_access') }}</button></span>
                                    </p>
                                </section>

                                <section class="us-card">
                                    <p class="us-card-k">{{ $t('admin_usuarios.r.account') }}</p>
                                    <ul class="us-kv">
                                        <li><span>{{ $t('admin_usuarios.r.registro') }}</span><b>{{ dia(U.fecha_registro) }}</b></li>
                                        <li><span>{{ $t('admin_usuarios.r.lang_cur') }}</span><b>{{ $t(`admin_usuarios.e.lang_${U.pref_lenguaje || 'es'}`) }} · {{ U.pref_moneda ? $t(`admin_usuarios.e.cur_${U.pref_moneda}`) : '—' }}</b></li>
                                        <li><span>{{ $t('admin_usuarios.r.identity') }}</span><b><span :class="['us-dotx', `us-dotx--${kyc.cls}`]"></span>{{ $t(`admin_usuarios.kyc.${kyc.k}`) }}</b></li>
                                        <template v-if="U.es_anfitrion">
                                            <li><span>{{ $t('admin_usuarios.r.model') }}</span><b>{{ (U.modelo && U.modelo.nombre) || $t('admin_usuarios.r.model_default') }}</b></li>
                                            <li><span>{{ $t('admin_usuarios.r.bank') }}</span><b>
                                                <template v-if="det.banco && det.banco.bank_name">{{ det.banco.bank_name }} {{ det.banco.cuenta }}</template>
                                                <template v-else-if="det.banco">{{ $t('admin_usuarios.r.bank_old') }}</template>
                                                <span v-else class="us-warn-t">{{ $t('admin_usuarios.r.bank_none') }}</span>
                                            </b></li>
                                        </template>
                                        <li v-if="U.referral_code"><span>{{ $t('admin_usuarios.r.ref') }}</span><b class="us-mono">{{ U.referral_code }}</b></li>
                                        <li v-if="U.is_admin"><span>{{ $t('admin_usuarios.r.perms') }}</span><b>{{ U.admin_permissions === null ? $t('admin_usuarios.r.perms_all') : $tc('admin_usuarios.r.perms_n', U.admin_permissions.length, { n: U.admin_permissions.length }) }}</b></li>
                                    </ul>
                                </section>
                            </div>

                            <section class="us-card">
                                <div class="us-card-head"><p class="us-card-k">{{ $t('admin_usuarios.r.last_moves') }}</p><button type="button" class="us-link" @click="cambiarTab('actividad')">{{ $t('admin_usuarios.r.all_activity') }}</button></div>
                                <ol v-if="movimientos.length" class="us-tl">
                                    <li v-for="(m, i) in movimientos.slice(0, 6)" :key="`r${i}`" :class="['us-tl-i', `us-tl-i--${m.ico}`]">
                                        <span class="us-tl-dot" aria-hidden="true"></span>
                                        <div class="us-tl-t"><b>{{ m.t }}</b><small>{{ m.d }}</small></div>
                                        <time class="us-tl-f" :datetime="m.f" :title="`${dia(m.f)} ${hora(m.f)}`">{{ hace(m.f) }}</time>
                                    </li>
                                </ol>
                                <p v-else class="us-muted">{{ $t('admin_usuarios.r.no_moves') }}</p>
                            </section>
                        </template>

                        <!-- ── Actividad ── -->
                        <template v-else-if="tab === 'actividad'">
                            <div class="us-seg us-seg--sm" role="group" :aria-label="$t('admin_usuarios.a.cat_label')">
                                <button v-for="c in categorias" :key="c.k || 'all'" type="button" :class="{ 'is-on': actCat === c.k }" :aria-pressed="String(actCat === c.k)" @click="actCat = c.k">
                                    {{ $t(`admin_usuarios.a.${c.k || 'all'}`) }}<span>{{ numero(c.n) }}</span>
                                </button>
                            </div>
                            <section class="us-card">
                                <template v-if="movimientosPorDia.length">
                                    <template v-for="g in movimientosPorDia">
                                        <h3 :key="`d${g.dia}`" class="us-tl-day">{{ etiquetaDia(g.dia) }}</h3>
                                        <ol :key="`l${g.dia}`" class="us-tl">
                                            <li v-for="(m, i) in g.items" :key="i" :class="['us-tl-i', `us-tl-i--${m.ico}`]">
                                                <span class="us-tl-dot" aria-hidden="true"></span>
                                                <div class="us-tl-t"><b>{{ m.t }}</b><small>{{ m.d }}</small></div>
                                                <time class="us-tl-f" :datetime="m.f" :title="`${dia(m.f)} ${hora(m.f)}`">{{ hace(m.f) }}</time>
                                            </li>
                                        </ol>
                                    </template>
                                </template>
                                <p v-else class="us-muted">{{ $t('admin_usuarios.a.empty') }}</p>
                            </section>
                            <p class="us-foot">{{ $t('admin_usuarios.a.foot') }}</p>
                        </template>
                        <!-- ── Datos ── -->
                        <form v-else-if="tab === 'datos'" class="us-form" novalidate @submit.prevent="guardar">
                            <fieldset class="us-fs" :disabled="!!bloqueo || guardando">
                                <section class="us-card">
                                    <div class="us-card-head"><h3 class="us-card-t">{{ $t('admin_usuarios.e.personal') }}</h3></div>
                                    <div class="us-g2">
                                        <label :class="['us-field', { 'is-invalid': err.nombre }]">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.nombre') }}</span>
                                            <input v-model="ed.nombre" type="text" maxlength="40" autocomplete="off" :aria-invalid="err.nombre ? 'true' : null" @input="limpiarErr('nombre')" />
                                            <span v-if="err.nombre" class="us-field-e">{{ err.nombre }}</span>
                                        </label>
                                        <label class="us-field">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.apellido') }}</span>
                                            <input v-model="ed.apellido" type="text" maxlength="40" autocomplete="off" />
                                        </label>
                                    </div>
                                    <label :class="['us-field', { 'is-invalid': err.correo }]">
                                        <span class="us-field-l">{{ $t('admin_usuarios.e.correo') }}</span>
                                        <input v-model="ed.correo" type="email" maxlength="100" autocomplete="off" :aria-invalid="err.correo ? 'true' : null" @input="limpiarErr('correo')" />
                                        <span v-if="err.correo" class="us-field-e">{{ err.correo }}</span>
                                    </label>
                                    <p v-if="correoCambio" class="us-note us-note--warn us-note--in"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_usuarios.e.mail_warn') }}</span></p>
                                    <div class="us-g2">
                                        <div>
                                            <label :class="['us-field', { 'is-invalid': err.telefono }]">
                                                <span class="us-field-l">{{ $t('admin_usuarios.e.telefono') }} <em v-if="U.telefono_verificado && !telCambio" class="us-ok-t">{{ $t('admin_usuarios.e.verified') }}</em></span>
                                                <input v-model="ed.telefono" type="tel" maxlength="45" autocomplete="off" :aria-invalid="err.telefono ? 'true' : null" @input="limpiarErr('telefono')" />
                                                <span v-if="err.telefono" class="us-field-e">{{ err.telefono }}</span>
                                            </label>
                                            <p v-if="telCambio && ed.telefono" class="us-note us-note--in"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_usuarios.e.tel_warn') }}</span></p>
                                        </div>
                                        <label :class="['us-field', { 'is-invalid': err.fecha_nacimiento }]">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.nacimiento') }}</span>
                                            <input v-model="ed.fecha_nacimiento" type="date" :max="hoyIso" @input="limpiarErr('fecha_nacimiento')" />
                                            <span v-if="err.fecha_nacimiento" class="us-field-e">{{ err.fecha_nacimiento }}</span>
                                        </label>
                                    </div>
                                    <label class="us-field">
                                        <span class="us-field-l">{{ $t('admin_usuarios.e.pais') }}</span>
                                        <select v-model="ed.pais_idpais">
                                            <option value="">{{ $t('admin_usuarios.d.no_country') }}</option>
                                            <option v-for="p in det.paises" :key="p.id" :value="String(p.id)">{{ p.nombre }}</option>
                                        </select>
                                    </label>
                                    <fieldset class="us-field us-radios">
                                        <legend class="us-field-l">{{ $t('admin_usuarios.e.sexo') }}</legend>
                                        <div class="us-seg us-seg--sm">
                                            <label v-for="s in SEXOS" :key="s" :class="{ 'is-on': ed.sexo === s }">
                                                <input v-model="ed.sexo" type="radio" name="us-sexo" :value="s" />{{ $t(`admin_usuarios.e.sx_${s}`) }}
                                            </label>
                                        </div>
                                    </fieldset>
                                    <label :class="['us-field', { 'is-invalid': err.biografia }]">
                                        <span class="us-field-l">{{ $t('admin_usuarios.e.bio') }} <em>{{ numero(ed.biografia.length) }}/1.000</em></span>
                                        <textarea v-model="ed.biografia" rows="3" maxlength="1000"></textarea>
                                    </label>
                                </section>

                                <section class="us-card">
                                    <div class="us-card-head"><h3 class="us-card-t">{{ $t('admin_usuarios.e.account') }}</h3></div>
                                    <div class="us-g2">
                                        <label class="us-field">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.tipo') }}</span>
                                            <select v-model="ed.tipo">
                                                <option value="">{{ $t('admin_usuarios.tipo.null') }}</option>
                                                <option v-for="t in ['huesped', 'anfitrion', 'property']" :key="t" :value="t">{{ $t(`admin_usuarios.tipo.${t}`) }}</option>
                                            </select>
                                        </label>
                                        <label v-if="ed.tipo === 'anfitrion' || ed.tipo === 'property' || U.es_anfitrion" class="us-field">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.modelo') }}</span>
                                            <select v-model="ed.modelo_anfitrion_id" :disabled="!det.puede.modelo">
                                                <option value="">{{ $t('admin_usuarios.r.model_default') }}</option>
                                                <option v-for="m in det.modelos" :key="m.id" :value="String(m.id)">{{ m.nombre }}</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div class="us-g2">
                                        <label class="us-field">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.idioma') }}</span>
                                            <select v-model="ed.pref_lenguaje"><option v-for="l in ['es', 'en']" :key="l" :value="l">{{ $t(`admin_usuarios.e.lang_${l}`) }}</option></select>
                                        </label>
                                        <label class="us-field">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.moneda') }}</span>
                                            <select v-model="ed.pref_moneda"><option v-for="m in MONEDAS" :key="m" :value="m">{{ $t(`admin_usuarios.e.cur_${m}`) }}</option></select>
                                        </label>
                                    </div>
                                    <p v-if="ed.tipo === 'property' && U.tipo !== 'property'" class="us-note us-note--warn us-note--in"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_usuarios.e.property_warn') }}</span></p>
                                </section>

                                <section v-if="U.es_anfitrion || ed.tipo === 'anfitrion' || ed.tipo === 'property'" class="us-card us-bank" @keydown.enter="enterBanco">
                                    <div class="us-card-head">
                                        <h3 class="us-card-t">{{ $t('admin_usuarios.e.bank') }}</h3>
                                        <button v-if="!banco.abierto && det.puede.banco" type="button" class="bk-btn bk-btn--ghost us-bank-open" :disabled="banco.cargando" @click="abrirBanco">
                                            <span v-if="banco.cargando" class="bk-spinner"></span>{{ $t(det.banco && det.banco.bank_name ? 'admin_usuarios.e.bank_edit_btn' : 'admin_usuarios.e.bank_add') }}
                                        </button>
                                    </div>

                                    <!-- Resumen enmascarado (lo que trae el detalle) -->
                                    <template v-if="!banco.abierto">
                                        <ul v-if="det.banco && det.banco.bank_name" class="us-kv">
                                            <li><span>{{ $t('admin_usuarios.e.bank_holder') }}</span><b>{{ det.banco.titular || '—' }}</b></li>
                                            <li><span>{{ $t('admin_usuarios.e.bank_name') }}</span><b>{{ det.banco.bank_name }}</b></li>
                                            <li><span>{{ $t('admin_usuarios.e.bank_acc') }}</span><b class="us-mono">{{ det.banco.cuenta }}</b></li>
                                            <li><span>{{ $t('admin_usuarios.e.bank_upd') }}</span><b>{{ dia(det.banco.updated_at) }}</b></li>
                                        </ul>
                                        <p v-else-if="det.banco" class="us-note"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_usuarios.e.bank_old') }}</span></p>
                                        <p v-else class="us-note us-note--warn"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_usuarios.e.bank_none_warn') }}</span></p>
                                    </template>

                                    <!-- Edición: los mismos 11 campos de /datos-bancarios -->
                                    <div v-else class="us-bank-form">
                                        <p class="us-note us-note--in"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_usuarios.e.bank_lead') }}</span></p>
                                        <div v-if="banco.anterior" class="us-bank-old">
                                            <span class="us-field-l">{{ $t('admin_usuarios.e.bank_old_label') }}</span>
                                            <p>{{ banco.anterior }}</p>
                                        </div>
                                        <div v-for="(fila, i) in CAMPOS_BANCO_FILAS" :key="i" :class="{ 'us-g2': fila.length > 1 }">
                                            <label v-for="c in fila" :key="c.k" :class="['us-field', { 'is-invalid': banco.err[c.k] }]">
                                                <span class="us-field-l">{{ $t(`datos_bancarios.f.${c.l}`) }} <em v-if="!c.req">{{ $t('datos_bancarios.optional') }}</em></span>
                                                <textarea v-if="c.area" v-model="banco.f[c.k]" rows="2" :maxlength="c.max" @input="limpiarErrBanco(c.k)"></textarea>
                                                <input v-else v-model="banco.f[c.k]" :type="c.type || 'text'" :maxlength="c.max" autocomplete="off" :class="{ 'us-mono': c.mono }" :aria-invalid="banco.err[c.k] ? 'true' : null" @input="limpiarErrBanco(c.k)" />
                                                <span v-if="banco.err[c.k]" class="us-field-e">{{ banco.err[c.k] }}</span>
                                            </label>
                                        </div>
                                        <p v-if="cuentaCambio" class="us-note us-note--warn us-note--in"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_usuarios.e.bank_acc_warn') }}</span></p>
                                        <div class="us-bank-actions">
                                            <button type="button" class="bk-btn bk-btn--ghost" :disabled="banco.guardando" @click="cerrarBanco">{{ $t('admin_usuarios.e.bank_cancel') }}</button>
                                            <button type="button" class="bk-btn bk-btn--primary" :disabled="!bancoCambios || banco.guardando" @click="guardarBanco"><span v-if="banco.guardando" class="bk-spinner"></span>{{ $t(banco.guardando ? 'admin_usuarios.e.saving' : 'admin_usuarios.e.bank_save') }}</button>
                                        </div>
                                    </div>
                                </section>
                            </fieldset>

                            <div class="us-bar">
                                <p :class="['us-bar-state', { 'is-dirty': sinGuardar }]"><span class="us-bar-dot"></span>{{ $t(hayCambios ? 'admin_usuarios.e.dirty' : bancoCambios ? 'admin_usuarios.e.bank_dirty' : 'admin_usuarios.e.saved_state') }}</p>
                                <div class="us-bar-actions">
                                    <button type="button" class="bk-btn bk-btn--ghost" :disabled="!hayCambios || guardando" @click="descartar">{{ $t('admin_usuarios.e.discard') }}</button>
                                    <button type="submit" class="bk-btn bk-btn--primary" :disabled="!hayCambios || guardando || !!bloqueo"><span v-if="guardando" class="bk-spinner"></span>{{ $t(guardando ? 'admin_usuarios.e.saving' : 'admin_usuarios.e.save') }}</button>
                                </div>
                            </div>
                        </form>
                        <!-- ── Reservas ── -->
                        <template v-else-if="tab === 'reservas'">
                            <div v-if="U.es_anfitrion" class="us-seg us-seg--sm" role="group" :aria-label="$t('admin_usuarios.res.label')">
                                <button type="button" :class="{ 'is-on': resTab === 'hechas' }" :aria-pressed="String(resTab === 'hechas')" @click="resTab = 'hechas'">{{ $t('admin_usuarios.res.made') }}<span>{{ numero(det.reservas.hechas_total) }}</span></button>
                                <button type="button" :class="{ 'is-on': resTab === 'recibidas' }" :aria-pressed="String(resTab === 'recibidas')" @click="resTab = 'recibidas'">{{ $t('admin_usuarios.res.recv') }}<span>{{ numero(det.reservas.recibidas_total) }}</span></button>
                            </div>
                            <template v-if="resLista.length">
                                <p class="us-sum">
                                    {{ $tc('admin_usuarios.res.sum_n', resTotal, { n: numero(resTotal) }) }} · {{ $tc('admin_usuarios.res.sum_paid', resResumen.pagadas, { n: numero(resResumen.pagadas) }) }} · {{ $t('admin_usuarios.res.sum_wait', { n: numero(resResumen.por_responder) }) }}
                                    <template v-if="resTotal > resLista.length"> · {{ $t('admin_usuarios.res.shown', { n: resLista.length }) }}</template>
                                </p>
                                <ul class="us-res-list">
                                    <li v-for="r in resLista" :key="r.idreserva" :class="['us-res', `us-res--${estadoRes(r).cls}`]">
                                        <div class="us-res-top">
                                            <b>#{{ r.idreserva }}</b>
                                            <span :class="['us-st', `us-st--${estadoRes(r).cls}`]">{{ $t(`admin_usuarios.res.st_${estadoRes(r).k}`) }}</span>
                                            <span v-if="r.status === 'accepted'" :class="['us-st', r.pagada ? 'us-st--ok' : 'us-st--wait']">{{ $t(r.pagada ? 'admin_usuarios.res.paid' : 'admin_usuarios.res.unpaid') }}</span>
                                            <small>{{ $t('admin_usuarios.res.requested', { d: dia(r.fecha_reserva) }) }}</small>
                                        </div>
                                        <p class="us-res-place">{{ r.alojamiento }}</p>
                                        <div class="us-res-meta">
                                            <span>{{ diaCorto(r.fecha_inicio) }} → {{ dia(r.fecha_termino) }}</span><i></i>
                                            <span>{{ $tc('admin_usuarios.res.nights', noches(r), { n: noches(r) }) }}</span><i></i>
                                            <span>{{ $tc('admin_usuarios.res.guests', r.huespedes, { n: r.huespedes }) }}</span>
                                            <template v-if="r.contraparte"><i></i><span>{{ $t(resTab === 'hechas' ? 'admin_usuarios.res.host' : 'admin_usuarios.res.guest', { n: r.contraparte }) }}</span></template>
                                        </div>
                                        <div class="us-res-foot">
                                            <span>{{ $t('admin_usuarios.res.stay') }} <b>{{ dinero(r.costo, r.moneda) }}</b></span>
                                            <router-link class="us-link" :to="{ name: 'reservations', query: { q: String(r.idreserva), r: String(r.idreserva) } }">{{ $t('admin_usuarios.res.open') }} <span aria-hidden="true" v-html="IC.ext"></span></router-link>
                                        </div>
                                    </li>
                                </ul>
                            </template>
                            <div v-else class="us-empty">
                                <h3>{{ $t(`admin_usuarios.res.empty_${resTab}`) }}</h3>
                                <p>{{ $t(`admin_usuarios.res.empty_${resTab}_t`) }}</p>
                            </div>
                        </template>

                        <!-- ── Intakes ── -->
                        <template v-else-if="tab === 'intakes'">
                            <section class="us-card us-intake-sum">
                                <div class="us-ring" :style="{ '--p': det.intakes_total ? Math.round(det.intakes_completos / det.intakes_total * 100) : 0 }" aria-hidden="true">
                                    <span>{{ numero(det.intakes_completos) }}<small>/{{ numero(det.intakes_total) }}</small></span>
                                </div>
                                <div>
                                    <h3 class="us-card-t">{{ det.intakes_total ? $t('admin_usuarios.in.title', { c: det.intakes_completos, t: det.intakes_total }) : $t('admin_usuarios.in.none') }}</h3>
                                    <p class="us-muted">{{ $t('admin_usuarios.in.lead') }}</p>
                                </div>
                            </section>
                            <p v-for="fp in det.formularios" :key="fp.id" class="us-note us-note--warn"><span aria-hidden="true" v-html="IC.warn"></span><span>{{ $t('admin_usuarios.in.form_warn', { n: fp.current_step, h: hace(fp.last_activity).toLowerCase() }) }}</span></p>
                            <ul v-if="det.intakes.length" class="us-int-list">
                                <li v-for="it in det.intakes" :key="it.id" class="us-int">
                                    <div class="us-res-top">
                                        <b>{{ $t('admin_usuarios.in.intake', { id: it.id }) }}</b>
                                        <span :class="['us-st', it.completo ? 'us-st--ok' : 'us-st--wait']">{{ $t(it.completo ? 'admin_usuarios.in.done' : 'admin_usuarios.in.wip') }}</span>
                                        <span :class="['us-st', `us-st--${estadoIntake(it).cls}`]">{{ $t(`admin_usuarios.in.st_${estadoIntake(it).k}`) }}</span>
                                        <small>{{ dia(it.created_at) }}</small>
                                    </div>
                                    <dl class="us-int-dl">
                                        <div><dt>{{ $t('admin_usuarios.in.programa') }}</dt><dd>{{ it.tipo_programa ? $te(`admin_usuarios.in.prog_${it.tipo_programa}`) ? $t(`admin_usuarios.in.prog_${it.tipo_programa}`) : it.tipo_programa : '—' }}</dd></div>
                                        <div><dt>{{ $t('admin_usuarios.in.destino') }}</dt><dd>{{ it.ciudad_destino || '—' }}</dd></div>
                                        <div><dt>{{ $t('admin_usuarios.in.uni') }}</dt><dd>{{ it.universidad_destino || it.universidad || '—' }}</dd></div>
                                        <div><dt>{{ $t('admin_usuarios.in.fechas') }}</dt><dd>{{ it.fecha_inicio ? `${diaCorto(it.fecha_inicio)} → ${dia(it.fecha_fin)}` : '—' }}</dd></div>
                                        <div><dt>{{ $t('admin_usuarios.in.presupuesto') }}</dt><dd>{{ it.presupuesto_usd ? $t('admin_usuarios.in.per_month', { n: numero(it.presupuesto_usd) }) : '—' }}</dd></div>
                                        <div><dt>{{ $t('admin_usuarios.in.busca') }}</dt><dd>{{ it.tipo_alojamiento || '—' }}<template v-if="it.cantidad_personas"> · {{ $tc('admin_usuarios.in.personas', it.cantidad_personas, { n: it.cantidad_personas }) }}</template></dd></div>
                                    </dl>
                                    <div class="us-res-foot">
                                        <span>{{ it.shortlist ? $tc('admin_usuarios.in.sent', it.shortlist, { n: it.shortlist }) : $t('admin_usuarios.in.none_sent') }}<template v-if="it.admin_intake"> · {{ $t('admin_usuarios.in.by', { n: it.admin_intake }) }}</template></span>
                                        <a class="us-link" :href="`/dashboard-intakes?intake=${it.id}`" target="_blank" rel="noopener">{{ $t('admin_usuarios.in.open') }} <span aria-hidden="true" v-html="IC.ext"></span></a>
                                    </div>
                                </li>
                            </ul>
                        </template>

                        <!-- ── Espacios ── -->
                        <template v-else-if="tab === 'espacios'">
                            <div class="us-figs us-figs--3">
                                <div class="us-fig"><span class="us-fig-n">{{ numero(det.espacios.publicados) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.es.pub') }}</span></div>
                                <div class="us-fig"><span class="us-fig-n">{{ numero(det.espacios.en_revision) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.es.rev') }}</span></div>
                                <div class="us-fig"><span class="us-fig-n">{{ numero(det.espacios.eliminados) }}</span><span class="us-fig-k">{{ $t('admin_usuarios.es.del') }}</span></div>
                            </div>
                            <p v-if="det.espacios.total > det.espacios.lista.length" class="us-sum">{{ $t('admin_usuarios.es.shown', { n: det.espacios.lista.length, t: numero(det.espacios.total) }) }}</p>
                            <ul class="us-al-list">
                                <li v-for="a in det.espacios.lista" :key="a.id">
                                    <a class="us-al" :href="`/alojamiento/${a.id}`" target="_blank" rel="noopener">
                                        <span class="us-al-ico" aria-hidden="true">{{ (a.nombre || '#')[0] }}</span>
                                        <span class="us-al-t"><b>{{ a.nombre }}</b><small>#{{ a.id }}<template v-if="a.categoria"> · {{ a.categoria }}</template><template v-if="a.precio"> · {{ dinero(a.precio, a.moneda) }}{{ $t('admin_usuarios.es.per_month') }}</template><template v-if="a.ical"> · {{ $t('admin_usuarios.es.ical') }}</template></small></span>
                                        <span :class="['us-st', `us-st--${a.eliminado ? 'off' : a.aprobado ? 'ok' : 'wait'}`]">{{ $t(`admin_usuarios.es.st_${a.eliminado ? 'del' : a.aprobado ? 'pub' : 'rev'}`) }}</span>
                                    </a>
                                </li>
                            </ul>
                            <router-link class="bk-btn bk-btn--ghost us-full" :to="{ name: 'admin-backoffice', query: { host: String(U.idusuario) } }">{{ $t('admin_usuarios.es.bo') }} <span aria-hidden="true" v-html="IC.ext"></span></router-link>
                        </template>
                        <!-- ── Seguridad ── -->
                        <template v-else-if="tab === 'seguridad'">
                            <p v-if="det.puede.es_vos" class="us-note"><span aria-hidden="true" v-html="IC.info"></span><span>{{ $t('admin_usuarios.s.own') }}</span></p>
                            <section class="us-card">
                                <div class="us-card-head"><h3 class="us-card-t"><span aria-hidden="true" v-html="IC.key"></span>{{ $t('admin_usuarios.s.pass') }}</h3></div>
                                <p class="us-muted">{{ $t(soloGoogle ? 'admin_usuarios.s.google_only' : 'admin_usuarios.s.lead') }}</p>
                                <div class="us-pass-opts">
                                    <div class="us-pass-opt">
                                        <b>{{ $t('admin_usuarios.s.link_t') }}</b>
                                        <p class="us-muted">{{ $t('admin_usuarios.s.link_p', { c: U.correo }) }}</p>
                                        <button type="button" class="bk-btn bk-btn--ghost" :disabled="!!bloqueo || accionando" @click="accion('enlace')"><span aria-hidden="true" v-html="IC.mail"></span>{{ $t('admin_usuarios.s.link_btn') }}</button>
                                    </div>
                                    <form class="us-pass-opt" novalidate @submit.prevent="accion('password')">
                                        <b>{{ $t('admin_usuarios.s.new_t') }}</b>
                                        <div class="us-pass-in">
                                            <label class="us-sr" for="us-pass-in">{{ $t('admin_usuarios.s.new_label') }}</label>
                                            <input id="us-pass-in" v-model="pass.valor" :type="pass.ver ? 'text' : 'password'" maxlength="10" autocomplete="new-password" :placeholder="$t('admin_usuarios.s.new_label')" :disabled="!!bloqueo || det.puede.es_vos" />
                                            <button type="button" class="us-icon-btn" :aria-label="$t(pass.ver ? 'admin_usuarios.s.hide' : 'admin_usuarios.s.show')" :aria-pressed="String(pass.ver)" @click="pass.ver = !pass.ver"><span aria-hidden="true" v-html="IC.eye"></span></button>
                                        </div>
                                        <ul class="us-rules">
                                            <li v-for="(ok, i) in reglas" :key="i" :class="{ 'is-ok': ok }"><span aria-hidden="true" v-html="IC.check"></span>{{ $t(`admin_usuarios.s.r${i + 1}`) }}</li>
                                        </ul>
                                        <label class="us-check"><input v-model="pass.avisar" type="checkbox" />{{ $t('admin_usuarios.s.notify') }}</label>
                                        <div class="us-pass-btns">
                                            <button type="button" class="bk-btn bk-btn--ghost" :disabled="!!bloqueo || det.puede.es_vos" @click="generarPass">{{ $t('admin_usuarios.s.generate') }}</button>
                                            <button type="submit" class="bk-btn bk-btn--primary" :disabled="!passOk || !!bloqueo || det.puede.es_vos || accionando">{{ $t('admin_usuarios.s.change') }}</button>
                                        </div>
                                    </form>
                                </div>
                            </section>

                            <section class="us-card">
                                <div class="us-card-head"><h3 class="us-card-t"><span aria-hidden="true" v-html="IC.out"></span>{{ $t('admin_usuarios.s.sessions') }}</h3></div>
                                <p class="us-muted">{{ $t('admin_usuarios.s.sessions_p') }}</p>
                                <button type="button" class="bk-btn bk-btn--ghost us-danger-btn" :disabled="!!bloqueo || det.puede.es_vos || accionando" @click="accion('sesiones')">{{ $t('admin_usuarios.s.sessions_btn') }}</button>
                            </section>

                            <section class="us-card">
                                <div class="us-card-head"><h3 class="us-card-t"><span aria-hidden="true" v-html="IC.phone"></span>{{ $t('admin_usuarios.s.verif') }}</h3></div>
                                <ul class="us-kv">
                                    <li><span>{{ $t('admin_usuarios.s.phone') }}</span><b>
                                        <template v-if="U.telefono">{{ U.telefono }} · <span :class="U.telefono_verificado ? 'us-ok-t' : 'us-warn-t'">{{ $t(U.telefono_verificado ? 'admin_usuarios.e.verified' : 'admin_usuarios.s.unverified') }}</span></template>
                                        <template v-else>{{ $t('admin_usuarios.s.no_phone') }}</template>
                                    </b></li>
                                    <li><span>{{ $t('admin_usuarios.s.identity') }}</span><b><span :class="['us-dotx', `us-dotx--${kyc.cls}`]"></span>{{ $t(`admin_usuarios.kyc.${kyc.k}`) }}<template v-if="U.kyc_verified_at"> · {{ dia(U.kyc_verified_at) }}</template></b></li>
                                </ul>
                                <button v-if="U.telefono && !U.telefono_verificado" type="button" class="bk-btn bk-btn--ghost" :disabled="!!bloqueo || accionando" @click="accion('codigo-wsp')"><span aria-hidden="true" v-html="IC.wa"></span>{{ $t('admin_usuarios.s.resend') }}</button>
                            </section>

                            <section v-if="U.is_admin" class="us-card">
                                <div class="us-card-head">
                                    <h3 class="us-card-t">{{ $t('admin_usuarios.s.perms') }}</h3>
                                    <router-link v-if="soySuper" class="us-link" :to="{ name: 'admin-permisos' }">{{ $t('admin_usuarios.s.perms_edit') }} <span aria-hidden="true" v-html="IC.ext"></span></router-link>
                                </div>
                                <p v-if="U.admin_permissions === null" class="us-muted">{{ $t('admin_usuarios.s.perms_all') }}</p>
                                <div v-else class="us-mods">
                                    <span v-for="m in modulosAdmin" :key="m.key" :class="{ 'is-on': U.admin_permissions.includes(m.key) }"><span v-if="U.admin_permissions.includes(m.key)" aria-hidden="true" v-html="IC.check"></span>{{ m.label }}</span>
                                </div>
                            </section>

                            <section class="us-card">
                                <div class="us-card-head"><h3 class="us-card-t"><span aria-hidden="true" v-html="IC.dev"></span>{{ $t('admin_usuarios.s.access') }}</h3><span class="us-muted">{{ $tc('admin_usuarios.s.access_n', det.accesos_total, { n: numero(det.accesos_total) }) }}</span></div>
                                <div v-if="det.accesos.length" class="us-table-w">
                                    <table class="us-table">
                                        <thead><tr><th scope="col">{{ $t('admin_usuarios.s.th_date') }}</th><th scope="col">{{ $t('admin_usuarios.s.th_what') }}</th><th scope="col">{{ $t('admin_usuarios.s.th_dev') }}</th><th scope="col">IP</th></tr></thead>
                                        <tbody>
                                            <tr v-for="l in det.accesos" :key="l.id" :class="{ 'is-bad': l.resultado === 'fallido' }">
                                                <td><b>{{ dia(l.fecha_hora) }}</b><small>{{ hora(l.fecha_hora) }}</small></td>
                                                <td>
                                                    <template v-if="l.evento === 'registro'">{{ $t('admin_usuarios.s.w_reg') }}</template>
                                                    <template v-else-if="l.resultado === 'fallido'"><span class="us-warn-t">{{ $t('admin_usuarios.s.w_fail') }}</span> · {{ $t(l.motivo === 'usuario_inexistente' ? 'admin_usuarios.mv.bad_user' : 'admin_usuarios.mv.bad_pass') }}</template>
                                                    <template v-else>{{ $t('admin_usuarios.s.w_ok') }}</template>
                                                    · {{ $t(l.metodo === 'google' ? 'admin_usuarios.r.m_google' : 'admin_usuarios.s.w_pass') }}
                                                </td>
                                                <td>{{ l.dispositivo || '—' }} · {{ l.sistema_operativo || '—' }}<small>{{ l.navegador || '' }}</small></td>
                                                <td class="us-mono">{{ l.ip || '—' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p v-else class="us-muted">{{ $t('admin_usuarios.s.access_empty') }}</p>
                            </section>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <!-- Confirmación -->
        <div v-if="modal" class="us-modal">
            <div class="us-modal-bg" @click="responderModal(false)"></div>
            <div ref="modalCard" class="us-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="us-m-title" aria-describedby="us-m-text">
                <h2 id="us-m-title">{{ modal.titulo }}</h2>
                <p id="us-m-text">{{ modal.texto }}</p>
                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="responderModal(false)">{{ $t('admin_usuarios.c.cancel') }}</button>
                    <button ref="modalOk" type="button" :class="['bk-btn', modal.peligro ? 'us-btn--danger' : 'bk-btn--primary']" @click="responderModal(true)">{{ modal.ok }}</button>
                </div>
            </div>
        </div>

        <transition name="us-toast">
            <div v-if="aviso" :class="['us-toast', `us-toast--${aviso.tipo}`]" role="status" aria-live="polite">
                <span class="us-toast-ico" aria-hidden="true">{{ aviso.tipo === 'ok' ? '✓' : aviso.tipo === 'error' ? '!' : 'i' }}</span><span>{{ aviso.txt }}</span>
            </div>
        </transition>
    </div>
</template>


<script>
import axios from 'axios';
import apiUrls from '@/new-constants/apiUrls';
import BkPaginacion from '@/components/Cuenta/BkPaginacion.vue';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';
import MODULOS from '@/components/Admin/modules.json';

// Íconos: texto fijo de este archivo, nunca datos del usuario.
const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    chev: P('<path d="m9 18 6-6-6-6"/>'),
    x: P('<path d="M18 6 6 18M6 6l12 12"/>'),
    ext: P('<path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/>'),
    info: P('<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>'),
    warn: P('<path d="M12 3 2 20h20z"/><path d="M12 10v4M12 17h.01"/>'),
    check: P('<path d="M20 6 9 17l-5-5"/>'),
    eye: P('<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>'),
    dev: P('<rect x="2" y="4" width="20" height="13" rx="2"/><path d="M8 21h8M12 17v4"/>'),
    phone: P('<rect x="6" y="2" width="12" height="20" rx="3"/><path d="M11 18h2"/>'),
    key: P('<circle cx="7.5" cy="15.5" r="4.5"/><path d="m10.7 12.3 9.3-9.3M17 6l3 3M14 9l2 2"/>'),
    wa: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22c5.46 0 9.9-4.45 9.9-9.91C21.95 6.45 17.5 2 12.04 2m5.8 14.16c-.24.68-1.42 1.31-1.97 1.39-.5.08-1.14.11-1.84-.12-.42-.13-.97-.31-1.67-.61-2.94-1.27-4.86-4.23-5-4.43-.15-.2-1.2-1.59-1.2-3.03s.76-2.15 1.03-2.44c.27-.3.58-.37.78-.37l.56.01c.18.01.42-.07.66.5.24.58.83 2.01.9 2.16.07.15.12.32.02.52-.1.2-.15.32-.29.5-.15.17-.31.38-.44.51-.15.15-.3.31-.13.6.17.3.76 1.25 1.63 2.03 1.12 1 2.06 1.31 2.36 1.46.3.15.47.12.64-.07.17-.2.74-.86.94-1.16.2-.3.39-.25.66-.15.27.1 1.7.8 1.99.95.29.15.48.22.55.34.07.13.07.72-.17 1.41"/></svg>',
    out: ICON.out, search: ICON.search, mail: ICON.mail, copy: ICON.copy,
};

const LOCALES = { es: 'es-CL', en: 'en-US', pt: 'pt-BR', fr: 'fr-FR', it: 'it-IT', de: 'de-DE' };
const TIPOS = ['', 'huesped', 'anfitrion', 'property', 'sin', 'admin'];
const ACTIVIDAD = [{ v: '', k: 'act_all' }, { v: 'hoy', k: 'hoy' }, { v: '7', k: 'd7' }, { v: '30', k: 'd30' }, { v: '90+', k: 'd90' }];
const ESTADO = [{ v: '', k: 'ver_all' }, { v: 'tel', k: 'tel' }, { v: 'sin-tel', k: 'sin_tel' }, { v: 'kyc', k: 'kyc' }, { v: 'sin-banco', k: 'sin_banco' }, { v: 'intake-sin-res', k: 'intake_sin_res' }, { v: 'fallidos', k: 'fallidos' }];
const ORDEN = ['registro', 'conexion', 'reservas', 'nombre'];
const REVISAR = ['sin-tel', 'sin-banco', 'intake-sin-res', 'fallidos'];
const TABS = ['resumen', 'actividad', 'datos', 'reservas', 'intakes', 'espacios', 'seguridad'];
const SEXOS = ['f', 'm', 'b', 'n'];
const MONEDAS = ['es_CL', 'es_AR', 'en_US', 'en_GB', 'it_IT'];
const CAMPOS = ['nombre', 'apellido', 'correo', 'telefono', 'fecha_nacimiento', 'sexo', 'pais_idpais', 'biografia', 'pref_lenguaje', 'pref_moneda', 'tipo', 'modelo_anfitrion_id'];
const DIA_MS = 86400000;

// Datos bancarios: mismos campos y reglas que /datos-bancarios (bankInformationRules.js).
// l = clave de `datos_bancarios.f.*` (se reusan esas etiquetas).
const CAMPOS_BANCO_FILAS = [
    [{ k: 'first_name', l: 'first_name', req: true, min: 2, max: 30 }, { k: 'last_name', l: 'last_name', req: true, min: 2, max: 40 }],
    [{ k: 'government_id', l: 'government_id', req: true, min: 5, max: 15 }, { k: 'phone', l: 'phone', type: 'tel', min: 6, max: 15 }],
    [{ k: 'email', l: 'email', type: 'email', max: 255 }],
    [{ k: 'bank_account_number', l: 'account', req: true, max: 255, mono: true }, { k: 'bank_code', l: 'bank_code', req: true, max: 255 }],
    [{ k: 'bank_name', l: 'bank_name', req: true, max: 255 }, { k: 'branch_code', l: 'branch_code', max: 50 }],
    [{ k: 'bank_address', l: 'bank_address', max: 150 }],
    [{ k: 'message', l: 'message', area: true, max: 255 }],
];
const CAMPOS_BANCO = [].concat(...CAMPOS_BANCO_FILAS);
const bancoVacio = () => ({ abierto: false, cargando: false, guardando: false, f: {}, orig: {}, err: {}, anterior: null });

const valorDe = (o, k) => (o[k] == null ? '' : String(o[k]));
// 'YYYY-MM-DD HH:MM:SS' en hora local (Safari no entiende el espacio).
const aFecha = s => {
    if (!s) return null;
    const d = new Date(String(s).slice(0, 19).replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
};
const digitos = v => String(v || '').replace(/\D/g, '');

export default {
    name: 'AdminUsuarios',
    components: { BkPaginacion, HyFLoader },
    data() {
        const q = this.$route.query;
        const s = k => (typeof q[k] === 'string' ? q[k] : '');
        return {
            IC, TIPOS, ACTIVIDAD, ESTADO, ORDEN, REVISAR, SEXOS, MONEDAS, CAMPOS_BANCO_FILAS,
            f: {
                q: s('q'),
                tipo: TIPOS.includes(s('tipo')) ? s('tipo') : '',
                act: ACTIVIDAD.some(o => o.v === s('act')) ? s('act') : '',
                ver: ESTADO.some(o => o.v === s('ver')) ? s('ver') : '',
                orden: ORDEN.includes(s('orden')) ? s('orden') : 'registro',
            },
            busqueda: s('q'),
            pagina: Number(q.page) > 0 ? Number(q.page) : 1,
            filas: [], total: 0, ultimaPagina: 1, resumen: null,
            cargando: true, error: false,
            // Hora del servidor y del navegador al recibirla: "hace X" se calcula
            // con el reloj de la API, no con el del admin.
            ahoraApi: null, ahoraCliente: Date.now(), reloj: Date.now(),
            abiertoId: Number(q.u) > 0 ? Number(q.u) : null,
            tab: TABS.includes(s('tab')) ? s('tab') : 'resumen',
            det: null, detCargando: false,
            cerrando: false, cookiesAlto: 0,
            ed: null, err: {}, guardando: false,
            banco: bancoVacio(),
            resTab: 'hechas', actCat: '',
            pass: { valor: '', ver: false, avisar: true },
            accionando: false,
            modal: null, aviso: null,
        };
    },
    computed: {
        loc() { return LOCALES[this.$i18n.locale] || 'es-CL'; },
        soySuper() { return !!this.$store.getters.isSuperAdmin; },
        filtrando() { return !!(this.f.q || this.f.tipo || this.f.act || this.f.ver || this.f.orden !== 'registro'); },
        cifras() {
            const r = this.resumen || {};
            return [
                { k: 'total', n: r.total },
                { k: 'act7', n: r.activos_7, f: ['act', '7'], on: this.f.act === '7' },
                { k: 'new30', n: r.nuevos_30 },
                { k: 'hosts', n: r.anfitriones, f: ['tipo', 'anfitrion'], on: this.f.tipo === 'anfitrion' },
                { k: 'guests', n: r.huespedes, f: ['tipo', 'huesped'], on: this.f.tipo === 'huesped' },
                { k: 'admins', n: r.admins, f: ['tipo', 'admin'], on: this.f.tipo === 'admin' },
            ];
        },
        U() { return this.det ? this.det.usuario : null; },
        bloqueo() { return this.det && !this.det.puede.editar ? this.det.puede.motivo : null; },
        telDigitos() { return this.U ? digitos(this.U.telefono) : ''; },
        tabs() {
            if (!this.det) return [];
            const d = this.det;
            const n = { reservas: d.reservas.hechas_total + d.reservas.recibidas_total, intakes: d.intakes_total, espacios: d.espacios.total };
            return TABS.filter(k => k !== 'espacios' || this.U.es_anfitrion).map(k => ({ k, n: n[k] || 0 }));
        },
        acceso() {
            const a = this.det && this.det.accesos.find(l => l.resultado === 'exitoso' && l.evento !== 'registro');
            return a || (this.det && this.det.accesos[0]) || null;
        },
        fallidos30() {
            if (!this.det) return 0;
            return this.det.accesos.filter(l => l.resultado === 'fallido' && this.diasDesde(l.fecha_hora) <= 30).length;
        },
        soloGoogle() {
            return !!(this.U && this.U.google && !this.det.accesos.some(l => l.metodo === 'password' && l.resultado === 'exitoso'));
        },
        kyc() {
            const k = this.U && ['approved', 'pending', 'declined'].includes(this.U.kyc_status) ? this.U.kyc_status : 'none';
            return { k, cls: { approved: 'ok', pending: 'wait', declined: 'bad', none: 'off' }[k] };
        },
        modulosAdmin() {
            return MODULOS.map(m => {
                const t = this.$t(m.title);
                return { key: m.key, label: t === m.title ? m.title : t };
            });
        },
        // ── Reservas
        resLista() { return this.det ? this.det.reservas[this.resTab] : []; },
        resTotal() { return this.det ? this.det.reservas[`${this.resTab}_total`] : 0; },
        resResumen() { return this.det ? this.det.reservas[`${this.resTab}_resumen`] : {}; },
        // ── Datos
        hoyIso() { return new Date().toISOString().slice(0, 10); },
        original() {
            if (!this.U) return null;
            const o = {};
            CAMPOS.forEach(k => { o[k] = valorDe(this.U, k); });
            if (!o.pref_lenguaje) o.pref_lenguaje = 'es';
            return o;
        },
        hayCambios() { return !!(this.ed && this.original && CAMPOS.some(k => String(this.ed[k]) !== this.original[k])); },
        correoCambio() { return !!(this.ed && this.ed.correo.trim().toLowerCase() !== String(this.U.correo || '').toLowerCase()); },
        telCambio() { return !!(this.ed && digitos(this.ed.telefono) !== digitos(this.U.telefono)); },
        // ── Datos bancarios
        bancoCambios() {
            const b = this.banco;
            return b.abierto && CAMPOS_BANCO.some(c => String(b.f[c.k] || '').trim() !== String(b.orig[c.k] || ''));
        },
        cuentaCambio() {
            const b = this.banco;
            return !!(b.abierto && b.orig.bank_account_number && String(b.f.bank_account_number || '').trim() !== b.orig.bank_account_number);
        },
        // Algo sin guardar en la pestaña Datos (datos de la cuenta o bancarios).
        sinGuardar() { return !!((this.ed && this.hayCambios) || this.bancoCambios); },
        // ── Contraseña (mismas reglas que el resto del sitio)
        reglas() {
            const v = this.pass.valor;
            return [v.length >= 6 && v.length <= 10, /[A-Z]/.test(v), /[a-z]/.test(v), /\d/.test(v)];
        },
        passOk() { return this.reglas.every(Boolean); },
        // ── Actividad
        movimientos() { return this.det ? this.armarMovimientos(this.det) : []; },
        categorias() {
            const todos = this.movimientos;
            return [''].concat(['accesos', 'reservas', 'intakes', 'espacios', 'cuenta'].filter(c => todos.some(m => m.cat === c)))
                .map(k => ({ k, n: k ? todos.filter(m => m.cat === k).length : todos.length }));
        },
        movimientosPorDia() {
            const lista = this.actCat ? this.movimientos.filter(m => m.cat === this.actCat) : this.movimientos;
            const out = [];
            lista.forEach(m => {
                const dia = String(m.f).slice(0, 10);
                const g = out[out.length - 1];
                if (g && g.dia === dia) g.items.push(m); else out.push({ dia, items: [m] });
            });
            return out;
        },
    },
    watch: {
        // Se espera a que termine de tipear; '#' delante del id se ignora.
        busqueda(v) {
            clearTimeout(this._t);
            this._t = setTimeout(() => {
                const term = String(v || '').trim();
                if (term === this.f.q) return;
                this.f.q = term;
                this.pagina = 1;
                this.cargar();
            }, 350);
        },
        tab() { this.syncUrl(); },
    },
    created() {
        this._t = null; this._req = 0; this._reqDet = 0; this._avisoT = null; this._foco = null;
        this.onKey = this.onKey.bind(this);
        this._relojT = setInterval(() => { this.reloj = Date.now(); }, 30000);
        this.cargar(true);
        if (this.abiertoId) this.abrir(this.abiertoId, this.tab);
    },
    beforeDestroy() {
        clearTimeout(this._t); clearTimeout(this._avisoT); clearInterval(this._relojT);
        this.alCerrar();
    },
    methods: {
        // ── Listado ──────────────────────────────────────────────────────
        async cargar(conResumen) {
            const req = ++this._req;
            this.cargando = true;
            this.error = false;
            this.syncUrl();
            const params = { page: this.pagina, per_page: 10 };
            Object.keys(this.f).forEach(k => { if (this.f[k] && !(k === 'orden' && this.f[k] === 'registro')) params[k] = this.f[k]; });
            if (conResumen || !this.resumen) params.resumen = 1;
            try {
                const { data } = await axios.get(apiUrls.adminUsuarios, { params });
                if (req !== this._req) return;
                this.filas = data.data || [];
                this.total = data.total || 0;
                this.ultimaPagina = data.last_page || 1;
                if (data.resumen) this.resumen = data.resumen;
                this.marcarHora(data.ahora);
                // La página pedida ya no existe (cambió el filtro desde un link viejo).
                if (this.pagina > this.ultimaPagina) { this.pagina = this.ultimaPagina; this.cargar(); }
            } catch (e) {
                if (req !== this._req) return;
                this.error = true;
            } finally {
                if (req === this._req) this.cargando = false;
            }
        },
        marcarHora(ahora) {
            if (!ahora) return;
            this.ahoraApi = aFecha(ahora);
            this.ahoraCliente = Date.now();
            this.reloj = Date.now();
        },
        syncUrl() {
            const q = {};
            if (this.f.q) q.q = this.f.q;
            if (this.f.tipo) q.tipo = this.f.tipo;
            if (this.f.act) q.act = this.f.act;
            if (this.f.ver) q.ver = this.f.ver;
            if (this.f.orden !== 'registro') q.orden = this.f.orden;
            if (this.pagina > 1) q.page = String(this.pagina);
            if (this.abiertoId) { q.u = String(this.abiertoId); if (this.tab !== 'resumen') q.tab = this.tab; }
            if (JSON.stringify(q) === JSON.stringify(this.$route.query)) return;
            this.$router.replace({ query: q }).catch(() => {});
        },
        cambiar(k, v) {
            if (this.f[k] === v) return;
            this.f[k] = v;
            this.pagina = 1;
            this.cargar();
        },
        filtroCifra([k, v]) { this.cambiar(k, this.f[k] === v ? '' : v); },
        limpiar() {
            this.f = { q: '', tipo: '', act: '', ver: '', orden: 'registro' };
            this.busqueda = '';
            this.pagina = 1;
            this.cargar();
        },
        irAPagina(p) {
            this.pagina = p;
            this.cargar();
            this.$nextTick(() => { const h = this.$el.querySelector('.us-head'); if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        },

        // ── Formato ──────────────────────────────────────────────────────
        numero(n) { return Number(n || 0).toLocaleString(this.loc); },
        nombre(u) { return `${u.nombre || ''} ${u.apellido || ''}`.replace(/\s+/g, ' ').trim() || this.$t('admin_usuarios.row.no_name'); },
        iniciales(u) {
            const p = this.nombre(u).split(' ');
            return ((p[0] || '?')[0] + (p[1] ? p[1][0] : '')).toUpperCase();
        },
        tipoCls(u) { return { huesped: 'h', anfitrion: 'a', property: 'p' }[u.tipo] || 'n'; },
        insignias(u) {
            const t = k => this.$t(`admin_usuarios.badge.${k}`);
            const out = [{ cls: `us-tipo us-tipo--${this.tipoCls(u)}`, t: this.$t(`admin_usuarios.tipo.${u.tipo || 'null'}`) }];
            if (u.is_super_admin) out.push({ cls: 'us-badge us-badge--adm', t: t('super') });
            else if (u.is_admin) out.push({ cls: 'us-badge us-badge--adm', t: t('admin') });
            if (u.telefono) out.push(u.telefono_verificado ? { cls: 'us-badge us-badge--ok', t: t('tel_ok') } : { cls: 'us-badge us-badge--wait', t: t('tel_no') });
            if (u.kyc_status === 'approved') out.push({ cls: 'us-badge us-badge--ok', t: t('kyc') });
            if (u.google) out.push({ cls: 'us-badge', t: 'Google' });
            if (u.facebook) out.push({ cls: 'us-badge', t: 'Facebook' });
            return out;
        },
        ahoraMs() {
            const base = this.ahoraApi ? this.ahoraApi.getTime() : this.ahoraCliente;
            return base + (this.reloj - this.ahoraCliente);
        },
        diasDesde(s) {
            const d = aFecha(s);
            return d ? Math.floor((this.ahoraMs() - d.getTime()) / DIA_MS) : Infinity;
        },
        hace(s) {
            const d = aFecha(s);
            if (!d) return this.$t('admin_usuarios.t.never');
            const min = Math.max(0, Math.round((this.ahoraMs() - d.getTime()) / 60000));
            if (min < 2) return this.$t('admin_usuarios.t.now');
            if (min < 60) return this.$t('admin_usuarios.t.min', { n: min });
            const h = Math.round(min / 60);
            if (h < 24) return this.$t('admin_usuarios.t.h', { n: h });
            const dias = Math.round(h / 24);
            if (dias === 1) return this.$t('admin_usuarios.t.yesterday');
            if (dias < 30) return this.$t('admin_usuarios.t.days', { n: dias });
            const meses = Math.round(dias / 30);
            if (meses < 12) return this.$tc('admin_usuarios.t.months', meses, { n: meses });
            const anios = Math.round(meses / 12);
            return this.$tc('admin_usuarios.t.years', anios, { n: anios });
        },
        vivo(s) {
            const d = this.diasDesde(s);
            return d <= 1 ? 'is-live' : d > 30 ? 'is-old' : '';
        },
        dia(s) {
            const d = aFecha(String(s || '').length === 10 ? `${s} 00:00:00` : s);
            return d ? d.toLocaleDateString(this.loc, { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
        },
        diaCorto(s) {
            const d = aFecha(String(s || '').length === 10 ? `${s} 00:00:00` : s);
            return d ? d.toLocaleDateString(this.loc, { day: 'numeric', month: 'short' }) : '—';
        },
        hora(s) {
            const d = aFecha(s);
            return d ? d.toLocaleTimeString(this.loc, { hour: '2-digit', minute: '2-digit' }) : '';
        },
        mesAnio(s) {
            const d = aFecha(s);
            return d ? d.toLocaleDateString(this.loc, { month: 'short', year: 'numeric' }) : '—';
        },
        etiquetaDia(dia) {
            const hoy = new Date(this.ahoraMs()); hoy.setHours(0, 0, 0, 0);
            const d = aFecha(`${dia} 00:00:00`);
            const n = d ? Math.round((hoy - d) / DIA_MS) : 99;
            return n <= 0 ? this.$t('admin_usuarios.t.today') : n === 1 ? this.$t('admin_usuarios.t.yesterday') : this.dia(dia);
        },
        dinero(m, moneda) {
            if (m == null) return '—';
            return `${moneda || ''} ${Number(m).toLocaleString(this.loc, { maximumFractionDigits: moneda === 'CLP' ? 0 : 2 })}`.trim();
        },
        noches(r) {
            const a = aFecha(`${r.fecha_inicio} 00:00:00`), b = aFecha(`${r.fecha_termino} 00:00:00`);
            return a && b ? Math.max(0, Math.round((b - a) / DIA_MS)) : 0;
        },
        estadoRes(r) {
            return {
                accepted: { k: 'ok', cls: 'ok' }, canceled: { k: 'off', cls: 'off' }, rejected: { k: 'bad', cls: 'bad' },
            }[r.status] || { k: 'wait', cls: 'wait' };
        },
        estadoIntake(i) {
            const k = ['pendiente', 'asignado', 'en_progreso', 'ganado', 'perdido', 'cooler'].includes(i.estado_intake) ? i.estado_intake : 'none';
            return { k, cls: { pendiente: 'wait', asignado: 'blue', en_progreso: 'blue', ganado: 'ok', perdido: 'bad', cooler: 'off', none: 'off' }[k] };
        },
        // ── Panel del usuario ────────────────────────────────────────────
        async abrir(id, tab, desde) {
            if (this.abiertoId && this.abiertoId !== id && this.sinGuardar && !(await this.preguntarSalir())) return;
            if (!this.abiertoId || !this._foco) this._foco = desde || document.activeElement;
            const yaAbierto = !!this.det && this.abiertoId === id;
            this.abiertoId = id;
            this.tab = tab || 'resumen';
            this.resTab = 'hechas'; this.actCat = '';
            this.pass = { valor: '', ver: false, avisar: true };
            if (!yaAbierto) { this.det = null; this.ed = null; this.err = {}; this.banco = bancoVacio(); }
            this.syncUrl();
            this.alAbrir();
            if (!yaAbierto) await this.cargarDetalle();
        },
        async cargarDetalle() {
            const id = this.abiertoId;
            const req = ++this._reqDet;
            this.detCargando = true;
            try {
                const { data } = await axios.get(apiUrls.adminUsuario(id));
                if (req !== this._reqDet || id !== this.abiertoId) return;
                this.det = data;
                this.marcarHora(data.ahora);
                if (this.tab === 'espacios' && !data.usuario.es_anfitrion) this.tab = 'resumen';
                if (this.tab === 'datos') this.prepararEdicion();
                this.$nextTick(() => { if (this.$refs.card) this.$refs.card.focus(); });
            } catch (e) {
                if (req === this._reqDet) this.det = null;
            } finally {
                if (req === this._reqDet) this.detCargando = false;
            }
        },
        alAbrir() {
            if (this._abierto) return;
            this._abierto = true;
            document.documentElement.classList.add('us-locked');
            document.addEventListener('keydown', this.onKey);
            this.medirCookies();
            this._cookiesT = setInterval(this.medirCookies, 800);
            this.$nextTick(() => { if (this.$refs.card) { this.$refs.card.scrollTop = 0; this.$refs.card.focus(); } });
        },
        alCerrar() {
            this._abierto = false;
            clearInterval(this._cookiesT);
            document.documentElement.classList.remove('us-locked');
            document.removeEventListener('keydown', this.onKey);
        },
        medirCookies() {
            const c = document.querySelector('.cookie-footer');
            const r = c ? c.getBoundingClientRect() : null;
            const visible = r && r.height > 0 && r.top < window.innerHeight && getComputedStyle(c).display !== 'none' && getComputedStyle(c).visibility !== 'hidden';
            this.cookiesAlto = visible ? Math.round(r.height) : 0;
        },
        async cerrar() {
            if (!this.abiertoId || this.cerrando) return;
            if (this.sinGuardar && !(await this.preguntarSalir())) return;
            this.cerrando = true;
            setTimeout(() => {
                this.cerrando = false;
                this.abiertoId = null; this.det = null; this.ed = null; this.err = {}; this.banco = bancoVacio();
                this.alCerrar();
                this.syncUrl();
                const el = this._foco;
                this._foco = null;
                if (el && document.contains(el)) el.focus();
            }, 200);
        },
        preguntarSalir() {
            return this.confirmar({ titulo: this.$t('admin_usuarios.c.leave_t'), texto: this.$t('admin_usuarios.c.leave_p'), ok: this.$t('admin_usuarios.c.leave_ok'), peligro: true });
        },
        async cambiarTab(k) {
            if (k === this.tab) return;
            if (this.tab === 'datos' && this.sinGuardar && !(await this.preguntarSalir())) return;
            if (this.tab === 'datos') { this.ed = null; this.err = {}; this.banco = bancoVacio(); }
            this.tab = k;
            if (k === 'datos') this.prepararEdicion();
            this.$nextTick(() => {
                const t = document.getElementById(`us-tab-${k}`);
                if (t) {
                    t.focus();
                    const bar = t.parentElement;
                    bar.scrollLeft = Math.max(0, t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2);
                }
                if (this.$refs.card) this.$refs.card.scrollTop = 0;
            });
        },
        irReservas(cual) { this.resTab = cual; this.cambiarTab('reservas'); },
        flechasTabs(e) {
            if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
            const ks = this.tabs.map(t => t.k);
            const i = ks.indexOf(this.tab);
            e.preventDefault();
            this.cambiarTab(ks[(i + (e.key === 'ArrowRight' ? 1 : -1) + ks.length) % ks.length]);
        },
        onKey(e) {
            const cont = this.modal ? this.$refs.modalCard : this.$refs.card;
            if (e.key === 'Escape') {
                e.preventDefault();
                if (this.modal) return this.responderModal(false);
                return this.cerrar();
            }
            if (e.key !== 'Tab' || !cont) return;
            const els = Array.from(cont.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')).filter(x => x.offsetParent !== null);
            if (!els.length) return;
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && (document.activeElement === first || document.activeElement === cont)) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },
        async copiar(txt) {
            try { await navigator.clipboard.writeText(txt); this.avisar(this.$t('admin_usuarios.d.copied'), 'ok'); } catch (e) { this.avisar(this.$t('admin_usuarios.d.copy_fail'), 'error'); }
        },

        // ── Línea de tiempo (sale de lo que trae el detalle) ─────────────
        armarMovimientos(d) {
            const t = (k, p) => this.$t(`admin_usuarios.mv.${k}`, p);
            const metodo = l => t(l.metodo === 'google' ? 'with_google' : 'with_pass');
            const disp = l => [l.dispositivo, l.sistema_operativo, l.navegador].filter(Boolean).join(' · ');
            const out = [];
            d.accesos.forEach(l => {
                if (l.evento === 'registro') out.push({ f: l.fecha_hora, cat: 'cuenta', ico: 'ok', t: t('registro'), d: [metodo(l), disp(l)].filter(Boolean).join(' · ') });
                else if (l.resultado === 'fallido') out.push({ f: l.fecha_hora, cat: 'accesos', ico: 'bad', t: t('fallido'), d: [t(l.motivo === 'usuario_inexistente' ? 'bad_user' : 'bad_pass'), l.dispositivo, l.ip ? `IP ${l.ip}` : ''].filter(Boolean).join(' · ') });
                else out.push({ f: l.fecha_hora, cat: 'accesos', ico: 'in', t: t('login'), d: [metodo(l), disp(l)].filter(Boolean).join(' · ') });
            });
            // Sin el historial de accesos (cuentas viejas) el registro igual aparece.
            if (!d.accesos.some(l => l.evento === 'registro') && d.usuario.fecha_registro) {
                out.push({ f: d.usuario.fecha_registro, cat: 'cuenta', ico: 'ok', t: t('registro'), d: '' });
            }
            const fechas = r => `${this.diaCorto(r.fecha_inicio)} → ${this.diaCorto(r.fecha_termino)}`;
            d.reservas.hechas.forEach(r => {
                out.push({ f: r.fecha_reserva, cat: 'reservas', ico: 'res', t: t('res_made', { id: r.idreserva }), d: `${r.alojamiento} · ${fechas(r)}` });
                if (r.pagada) out.push({ f: r.fecha_pago, cat: 'reservas', ico: 'ok', t: t('res_paid', { id: r.idreserva }), d: r.alojamiento });
            });
            d.reservas.recibidas.forEach(r => out.push({ f: r.fecha_reserva, cat: 'reservas', ico: 'res', t: t('res_recv', { id: r.idreserva }), d: [r.contraparte, r.alojamiento].filter(Boolean).join(' · ') }));
            d.intakes.forEach(i => out.push({ f: i.created_at, cat: 'intakes', ico: i.completo ? 'ok' : 'wait', t: t(i.completo ? 'intake_ok' : 'intake_wip'), d: [i.ciudad_destino, i.presupuesto_usd ? `USD ${this.numero(i.presupuesto_usd)}` : ''].filter(Boolean).join(' · ') }));
            d.formularios.forEach(fp => out.push({ f: fp.last_activity, cat: 'intakes', ico: 'wait', t: t('form', { n: fp.current_step }), d: t('form_d') }));
            d.ediciones.forEach(e => {
                const k = ['editado', 'publicado', 'ocultado', 'creado', 'eliminado'].includes(e.accion) ? e.accion : 'otro';
                const quien = !e.por_el ? (e.origen === 'admin' ? t('ed_by_admin') : e.origen === 'sql_directo' ? t('ed_by_sql') : '') : '';
                out.push({ f: e.fecha_hora, cat: 'espacios', ico: 'edit', t: t(`ed_${k}`, { id: e.idalojamiento }), d: [e.alojamiento, quien].filter(Boolean).join(' · ') });
            });
            d.cambios.forEach(c => {
                const por = c.por ? t('by', { n: c.por }) : '';
                let det = '';
                if (c.tipo === 'admin_datos' && c.detalle && c.detalle.campos) det = Object.keys(c.detalle.campos).map(k => this.$t(`admin_usuarios.campo.${k}`)).join(', ');
                if (c.tipo === 'admin_password') det = t(c.detalle && c.detalle.avisado ? 'notified' : 'not_notified');
                if (c.tipo === 'modelo') det = `${(c.detalle && c.detalle.de) || this.$t('admin_usuarios.r.model_default')} → ${(c.detalle && c.detalle.a) || this.$t('admin_usuarios.r.model_default')}`;
                if (c.tipo === 'recuperacion') det = t(c.detalle && c.detalle.usado ? 'used' : 'unused');
                const conocido = this.$te(`admin_usuarios.mv.${c.tipo}`);
                out.push({ f: c.fecha, cat: 'cuenta', ico: c.tipo.indexOf('admin_') === 0 ? 'admin' : 'edit', t: conocido ? t(c.tipo) : c.tipo, d: [det, por].filter(Boolean).join(' · ') });
            });
            return out.filter(m => m.f).sort((a, b) => String(b.f).localeCompare(String(a.f)));
        },

        // ── Datos ────────────────────────────────────────────────────────
        prepararEdicion() {
            if (!this.U) return;
            this.ed = { ...this.original };
            if (!this.ed.pref_lenguaje) this.ed.pref_lenguaje = 'es';
            this.err = {};
        },
        descartar() { this.prepararEdicion(); },
        limpiarErr(k) { if (this.err[k]) this.$delete(this.err, k); },
        validar() {
            const e = {}, t = k => this.$t(`admin_usuarios.e.err_${k}`);
            if (!this.ed.nombre.trim()) e.nombre = t('required');
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.ed.correo.trim())) e.correo = t('email');
            if (this.ed.telefono && digitos(this.ed.telefono).length < 8) e.telefono = t('phone');
            if (this.ed.fecha_nacimiento && this.ed.fecha_nacimiento > this.hoyIso) e.fecha_nacimiento = t('date');
            if (this.ed.biografia.length > 1000) e.biografia = t('bio');
            return e;
        },
        async guardar() {
            if (!this.hayCambios || this.guardando || this.bloqueo) return;
            const e = this.validar();
            this.err = e;
            if (Object.keys(e).length) return this.fallaForm();
            this.guardando = true;
            const body = {};
            CAMPOS.forEach(k => { body[k] = this.ed[k] === '' ? null : this.ed[k]; });
            body.nombre = this.ed.nombre.trim();
            body.correo = this.ed.correo.trim();
            body.biografia = this.ed.biografia;
            try {
                const { data } = await axios.put(apiUrls.adminUsuario(this.abiertoId), body);
                // Lo guardado se ve enseguida; el detalle completo se recarga detrás.
                const u = this.det.usuario;
                CAMPOS.forEach(k => {
                    const v = body[k];
                    u[k] = ['pais_idpais', 'modelo_anfitrion_id'].includes(k) ? (v ? Number(v) : null) : v;
                });
                const pais = this.det.paises.find(p => p.id === u.pais_idpais);
                u.pais = pais ? pais.nombre : null;
                if (data.cambios && data.cambios.includes('telefono')) u.telefono_verificado = false;
                this.prepararEdicion();
                this.avisar(this.$t(data.cambios && data.cambios.length ? 'admin_usuarios.toast.saved' : 'admin_usuarios.toast.nochange'), 'ok');
                await this.refrescar();
                if (!this.hayCambios) this.prepararEdicion();
            } catch (err) {
                const r = err.response;
                if (r && r.status === 422 && r.data) {
                    const m = {};
                    const map = { correo: 'email_taken', telefono: 'phone_taken' };
                    Object.keys(r.data).forEach(k => {
                        const raw = String((r.data[k] || [])[0] || '');
                        m[k] = /unique/.test(raw) && map[k] ? this.$t(`admin_usuarios.e.err_${map[k]}`) : this.$t(`admin_usuarios.e.err_${k === 'correo' ? 'email' : k === 'telefono' ? 'phone' : k === 'fecha_nacimiento' ? 'date' : 'generic_field'}`);
                    });
                    this.err = m;
                    this.fallaForm();
                } else {
                    this.avisarError(r);
                }
            } finally {
                this.guardando = false;
            }
        },
        // ── Datos bancarios ─────────────────────────────────────────────
        // Los completos se piden recién al abrir el formulario (el detalle los trae enmascarados).
        async abrirBanco() {
            if (this.banco.cargando || !this.det.puede.banco) return;
            const id = this.abiertoId;
            this.banco.cargando = true;
            try {
                const { data } = await axios.get(apiUrls.adminUsuarioAccion(id, 'banco'));
                if (id !== this.abiertoId) return;
                const orig = {};
                CAMPOS_BANCO.forEach(c => { orig[c.k] = data.data && data.data[c.k] != null ? String(data.data[c.k]) : ''; });
                this.banco = { ...bancoVacio(), abierto: true, f: { ...orig }, orig, anterior: data.formato_anterior || null };
                this.$nextTick(() => { const i = this.$el.querySelector('.us-bank-form input'); if (i) i.focus(); });
            } catch (err) {
                this.banco.cargando = false;
                this.avisarError(err.response);
            }
        },
        async cerrarBanco() {
            if (this.bancoCambios && !(await this.confirmar({ titulo: this.$t('admin_usuarios.c.bank_discard_t'), texto: this.$t('admin_usuarios.c.bank_discard_p'), ok: this.$t('admin_usuarios.c.bank_discard_ok'), peligro: true }))) return;
            this.banco = bancoVacio();
        },
        limpiarErrBanco(k) { if (this.banco.err[k]) this.$delete(this.banco.err, k); },
        // Enter en un campo del banco guarda el banco, no el formulario de la cuenta.
        enterBanco(e) {
            if (!this.banco.abierto || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'BUTTON') return;
            e.preventDefault();
            this.guardarBanco();
        },
        validarBanco() {
            const e = {}, f = this.banco.f, t = (k, p) => this.$t(`admin_usuarios.e.err_${k}`, p);
            CAMPOS_BANCO.forEach(c => {
                const v = String(f[c.k] || '').trim();
                if (!v) { if (c.req) e[c.k] = t('required'); return; }
                if (c.min && v.length < c.min) e[c.k] = t('min', { n: c.min });
                else if (v.length > c.max) e[c.k] = t('max', { n: c.max });
            });
            if (!e.email && f.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(f.email).trim())) e.email = t('email');
            return e;
        },
        async guardarBanco() {
            const b = this.banco;
            if (!b.abierto || b.guardando || !this.bancoCambios || this.bloqueo) return;
            const e = this.validarBanco();
            b.err = e;
            if (Object.keys(e).length) {
                this.avisar(this.$t('admin_usuarios.e.err_generic'), 'error');
                this.$nextTick(() => { const i = this.$el.querySelector('.us-bank-form .us-field.is-invalid input, .us-bank-form .us-field.is-invalid textarea'); if (i) i.focus(); });
                return;
            }
            const n = this.nombre(this.U);
            const ok = await this.confirmar({
                titulo: this.$t('admin_usuarios.c.bank_t'),
                texto: this.$t(this.cuentaCambio ? 'admin_usuarios.c.bank_p_acc' : 'admin_usuarios.c.bank_p', { n }),
                ok: this.$t('admin_usuarios.c.bank_ok'),
                peligro: this.cuentaCambio,
            });
            if (!ok) return;
            const id = this.abiertoId;
            const body = {};
            CAMPOS_BANCO.forEach(c => { const v = String(b.f[c.k] || '').trim(); body[c.k] = v === '' ? null : v; });
            b.guardando = true;
            try {
                const { data } = await axios.put(apiUrls.adminUsuarioAccion(id, 'banco'), body);
                if (id !== this.abiertoId) return;
                // Lo guardado se ve enseguida (enmascarado); el detalle completo se recarga detrás.
                const num = digitos(body.bank_account_number) || String(body.bank_account_number || '');
                if (data.cambios && data.cambios.length) this.det.banco = {
                    bank_name: body.bank_name, titular: [body.first_name, body.last_name].filter(Boolean).join(' '),
                    cuenta: num.length > 4 ? `•••• ${num.slice(-4)}` : '••••', updated_at: data.updated_at || this.det.ahora,
                };
                this.banco = bancoVacio();
                this.avisar(this.$t(data.cambios && data.cambios.length ? 'admin_usuarios.toast.bank_saved' : 'admin_usuarios.toast.nochange'), 'ok');
                await this.refrescar();
            } catch (err) {
                b.guardando = false;
                const r = err.response;
                if (r && r.status === 422 && r.data) {
                    const m = {};
                    Object.keys(r.data).forEach(k => {
                        const c = CAMPOS_BANCO.find(x => x.k === k);
                        const raw = String((r.data[k] || [])[0] || '');
                        m[k] = /required/.test(raw) ? this.$t('admin_usuarios.e.err_required')
                            : /min/.test(raw) && c && c.min ? this.$t('admin_usuarios.e.err_min', { n: c.min })
                            : /max/.test(raw) && c ? this.$t('admin_usuarios.e.err_max', { n: c.max })
                            : /email/.test(raw) ? this.$t('admin_usuarios.e.err_email') : this.$t('admin_usuarios.e.err_generic_field');
                    });
                    b.err = m;
                    this.avisar(this.$t('admin_usuarios.e.err_generic'), 'error');
                } else {
                    this.avisarError(r);
                }
            }
        },
        fallaForm() {
            this.avisar(this.$t('admin_usuarios.e.err_generic'), 'error');
            this.$nextTick(() => { const f = this.$el.querySelector('.us-field.is-invalid input, .us-field.is-invalid textarea'); if (f) f.focus(); });
        },
        // Vuelve a pedir el detalle (y la fila / cifras) después de una acción.
        async refrescar() {
            const id = this.abiertoId;
            try {
                const { data } = await axios.get(apiUrls.adminUsuario(id));
                if (id === this.abiertoId) { this.det = data; this.marcarHora(data.ahora); }
            } catch (e) { /* el panel queda con lo que tenía */ }
            this.cargar(true);
        },

        // ── Seguridad ────────────────────────────────────────────────────
        generarPass() {
            const M = 'ABCDEFGHJKLMNPQRSTUVWXYZ', m = 'abcdefghijkmnpqrstuvwxyz', d = '23456789', todo = M + m + d;
            const r = new Uint32Array(12);
            window.crypto.getRandomValues(r);
            const chars = [M[r[0] % M.length], m[r[1] % m.length], d[r[2] % d.length]];
            for (let i = 3; i < 10; i++) chars.push(todo[r[i] % todo.length]);
            // Mezcla de Fisher-Yates con el mismo generador.
            const s = new Uint32Array(10);
            window.crypto.getRandomValues(s);
            for (let i = chars.length - 1; i > 0; i--) { const j = s[i] % (i + 1); [chars[i], chars[j]] = [chars[j], chars[i]]; }
            this.pass.valor = chars.join('');
            this.pass.ver = true;
        },
        async accion(act) {
            if (this.accionando || !this.U) return;
            const n = this.nombre(this.U);
            const C = {
                enlace: { titulo: 'link_t', texto: this.$t('admin_usuarios.c.link_p', { c: this.U.correo }), ok: 'link_ok' },
                password: { titulo: 'pass_t', texto: this.$t(this.pass.avisar ? 'admin_usuarios.c.pass_p_mail' : 'admin_usuarios.c.pass_p', { n }), ok: 'pass_ok', peligro: true },
                sesiones: { titulo: 'ses_t', texto: this.$t('admin_usuarios.c.ses_p', { n }), ok: 'ses_ok', peligro: true },
                'codigo-wsp': { titulo: 'code_t', texto: this.$t('admin_usuarios.c.code_p', { t: this.U.telefono }), ok: 'code_ok' },
            }[act];
            if (act === 'password' && !this.passOk) return;
            if (!(await this.confirmar({ titulo: this.$t(`admin_usuarios.c.${C.titulo}`), texto: C.texto, ok: this.$t(`admin_usuarios.c.${C.ok}`), peligro: C.peligro }))) return;
            this.accionando = true;
            try {
                const body = act === 'password' ? { password: this.pass.valor, avisar: this.pass.avisar ? 1 : 0 } : {};
                const { data } = await axios.post(apiUrls.adminUsuarioAccion(this.abiertoId, act), body);
                const msg = {
                    enlace: this.$t('admin_usuarios.toast.link', { c: this.U.correo }),
                    password: this.$t(data.avisado ? 'admin_usuarios.toast.pass_notified' : 'admin_usuarios.toast.pass'),
                    sesiones: this.$t('admin_usuarios.toast.ses'),
                    'codigo-wsp': this.$t('admin_usuarios.toast.code'),
                }[act];
                if (act === 'password') this.pass = { valor: '', ver: false, avisar: true };
                this.avisar(msg, 'ok');
                await this.refrescar();
            } catch (err) {
                this.avisarError(err.response);
            } finally {
                this.accionando = false;
            }
        },
        avisarError(r) {
            const code = r && r.data && r.data.code;
            const k = {
                E_SIN_PERMISO: 'forbidden', E_PROPIA: 'own', E_APAGADA: 'code_off', E_VERIFICADO: 'code_verified', E_ESPERA: 'code_wait', E_SIN_TELEFONO: 'no_phone',
            }[code];
            if (r && r.status === 422 && r.data && r.data.password) return this.avisar(this.$t('admin_usuarios.toast.weak'), 'error');
            this.avisar(this.$t(`admin_usuarios.toast.${k || 'error'}`, { n: (r && r.data && r.data.segundos_restantes) || 60 }), 'error');
        },

        // ── Confirmación y aviso ─────────────────────────────────────────
        confirmar({ titulo, texto, ok, peligro }) {
            return new Promise(resolve => {
                this._modalFoco = document.activeElement;
                this.modal = { titulo, texto, ok, peligro: !!peligro, resolve };
                if (!this._abierto) document.addEventListener('keydown', this.onKey);
                this.$nextTick(() => { if (this.$refs.modalOk) this.$refs.modalOk.focus(); });
            });
        },
        responderModal(v) {
            if (!this.modal) return;
            const { resolve } = this.modal;
            this.modal = null;
            if (!this._abierto) document.removeEventListener('keydown', this.onKey);
            const el = this._modalFoco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            resolve(v);
        },
        avisar(txt, tipo) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, tipo: tipo || 'ok' };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3500);
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="./usuariosAdmin.css"></style>
